import { toURLSearchParams, resolveUrl, } from '@wix/sdk-runtime/rest-modules';
export class WixDataItemsHttpClient {
    constructor(httpClient, interceptor, sideEffects) {
        this.httpClient = httpClient;
        this.interceptor = interceptor;
        this.sideEffects = sideEffects;
    }
    getDataItem(request) {
        return this.execHttpCall(getDataItemRequestOptions, request);
    }
    insertDataItem(request) {
        return this.execHttpCall(insertDataItemRequestOptions, request);
    }
    updateDataItem(request) {
        return this.execHttpCall(updateDataItemRequestOptions, request);
    }
    patchDataItem(request) {
        return this.execHttpCall(patchDataItemRequestOptions, request);
    }
    saveDataItem(request) {
        return this.execHttpCall(saveDataItemRequestOptions, request);
    }
    removeDataItem(request) {
        return this.execHttpCall(removeDataItemRequestOptions, request);
    }
    truncateDataItems(request) {
        return this.execHttpCall(truncateDataItemsRequestOptions, request);
    }
    bulkInsertDataItems(request) {
        return this.execHttpCall(bulkInsertDataItemsRequestOptions, request);
    }
    bulkPatchDataItems(request) {
        return this.execHttpCall(bulkPatchDataItemsRequestOptions, request);
    }
    bulkUpdateDataItems(request) {
        return this.execHttpCall(bulkUpdateDataItemsRequestOptions, request);
    }
    bulkSaveDataItems(request) {
        return this.execHttpCall(bulkSaveDataItemsRequestOptions, request);
    }
    bulkRemoveDataItems(request) {
        return this.execHttpCall(bulkRemoveDataItemsRequestOptions, request);
    }
    isReferencedDataItem(request) {
        return this.execHttpCall(isReferencedDataItemRequestOptions, request);
    }
    bulkInsertDataItemReferences(request) {
        return this.execHttpCall(bulkInsertDataItemReferencesRequestOptions, request);
    }
    bulkRemoveDataItemReferences(request) {
        return this.execHttpCall(bulkRemoveDataItemReferencesRequestOptions, request);
    }
    replaceDataItemReferences(request) {
        return this.execHttpCall(replaceDataItemReferencesRequestOptions, request);
    }
    countDataItems(request) {
        return this.execHttpCall(countDataItemsRequestOptions, request);
    }
    queryDistinctValues(request) {
        return this.execHttpCall(queryDistinctValuesRequestOptions, request);
    }
    queryDataItems(request) {
        return this.execHttpCall(queryDataItemsRequestOptions, request);
    }
    aggregateDataItems(request) {
        return this.execHttpCall(aggregateDataItemsRequestOptions, request);
    }
    aggregatePipelineDataItems(request) {
        return this.execHttpCall(aggregatePipelineDataItemsRequestOptions, request);
    }
    queryReferencedDataItems(request) {
        return this.execHttpCall(queryReferencedDataItemsRequestOptions, request);
    }
    searchDataItems(request) {
        return this.execHttpCall(searchDataItemsRequestOptions, request);
    }
    async execHttpCall(params, payload) {
        const reqOpts = reqOptions(params, payload);
        this.sideEffects?.onSiteCall?.();
        try {
            const result = await this.httpClient.request((ctx) => {
                const req = reqOpts(ctx);
                const intercepted = this.interceptor(req);
                return intercepted;
            });
            this.sideEffects?.onSuccess?.(result);
            return result;
        }
        catch (err) {
            this.sideEffects?.onError?.(err);
            throw err;
        }
    }
}
export const getDataItemRequestOptions = {
    method: 'GET',
    methodName: 'GetDataItem',
    httpPath: '/v2/items/{dataItemId}',
};
export const insertDataItemRequestOptions = {
    method: 'POST',
    methodName: 'InsertDataItem',
    httpPath: '/v2/items',
};
export const updateDataItemRequestOptions = {
    method: 'POST',
    methodName: 'UpdateDataItem',
    httpPath: '/v2/items/update',
};
export const patchDataItemRequestOptions = {
    method: 'POST',
    methodName: 'PatchDataItem',
    httpPath: '/v2/items/patch',
};
export const saveDataItemRequestOptions = {
    method: 'POST',
    methodName: 'SaveDataItem',
    httpPath: '/v2/items/save',
};
export const removeDataItemRequestOptions = {
    method: 'POST',
    methodName: 'RemoveDataItem',
    httpPath: '/v2/items/remove',
};
export const truncateDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'TruncateDataItems',
    httpPath: '/v2/items/truncate',
};
export const bulkInsertDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'BulkInsertDataItems',
    httpPath: '/v2/bulk/items/insert',
};
export const bulkUpdateDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'BulkUpdateDataItems',
    httpPath: '/v2/bulk/items/update',
};
export const bulkPatchDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'BulkPatchDataItems',
    httpPath: '/v2/bulk/items/patch',
};
export const bulkSaveDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'BulkSaveDataItems',
    httpPath: '/v2/bulk/items/save',
};
export const bulkRemoveDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'BulkRemoveDataItems',
    httpPath: '/v2/bulk/items/remove',
};
export const isReferencedDataItemRequestOptions = {
    method: 'POST',
    methodName: 'IsReferencedDataItem',
    httpPath: '/v2/items/is-referenced',
};
export const bulkInsertDataItemReferencesRequestOptions = {
    method: 'POST',
    methodName: 'BulkInsertDataItemReferences',
    httpPath: '/v2/bulk/items/insert-references',
};
export const bulkRemoveDataItemReferencesRequestOptions = {
    method: 'POST',
    methodName: 'BulkRemoveDataItemReferences',
    httpPath: '/v2/bulk/items/remove-references',
};
export const replaceDataItemReferencesRequestOptions = {
    method: 'POST',
    methodName: 'ReplaceDataItemReferences',
    httpPath: '/v2/items/replace-references',
};
export const countDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'CountDataItems',
    httpPath: '/v2/items/count',
};
export const queryDistinctValuesRequestOptions = {
    method: 'POST',
    methodName: 'QueryDistinctValues',
    httpPath: '/v2/items/query-distinct-values',
};
export const queryDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'QueryDataItems',
    httpPath: '/v2/items/query',
};
export const aggregateDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'AggregateDataItems',
    httpPath: '/v2/items/aggregate',
};
export const aggregatePipelineDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'AggregatePipelineDataItems',
    httpPath: '/v2/items/aggregate-pipeline',
};
export const queryReferencedDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'QueryReferencedDataItems',
    httpPath: '/v2/items/query-referenced',
};
export const searchDataItemsRequestOptions = {
    method: 'POST',
    methodName: 'SearchDataItems',
    httpPath: '/v2/items/search',
};
export const reqOptions = ({ method, methodName, httpPath }, payload) => {
    const useSearchParams = method === 'GET' || method === 'DELETE';
    return ({ host }) => ({
        entityFqdn: 'wix.data.v2.data_item',
        method,
        methodFqn: `com.wixpress.cloud.data.api.data.DataItemService.${methodName}`,
        url: resolveServiceUrl({
            protoPath: httpPath,
            data: payload,
            host,
        }),
        data: useSearchParams ? undefined : payload,
        params: useSearchParams ? toURLSearchParams(payload) : undefined,
    });
};
const resolveServiceUrl = (opts) => {
    const domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/cloud-data',
                destPath: '',
            },
        ],
        'cloud-data.wix-code.com': [
            {
                srcPath: '',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
            {
                srcPath: '/_api/data',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
            {
                srcPath: '/_api/data',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/cloud-data/v2/bulk',
                destPath: '/v2/bulk',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/wix-data/v2',
                destPath: '/v2',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
};
//# sourceMappingURL=data-items-api-client.js.map